import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { ConfirmationService, Message, MessageService, TreeNode } from 'primeng/api';
import { FAZILService } from 'src/app/core/services/fazil.service';
import { User, UserService } from 'src/app/core';
import { AdministracionService } from '../administracion.service';
import { UIService } from 'src/app/core/services/ui.service';

import { EliminarData } from 'src/app/modelo/EliminarData';
import { DashboardIndicador } from 'src/app/modelo/DashboardIndicador';
import { Md5 } from 'md5-typescript';

@Component({
    selector: 'app-admin-indicadores',
    templateUrl: './admin-indicadores.component.html',
    styleUrls: ['./admin-indicadores.component.scss']
})
export class AdminIndicadoresComponent implements OnInit {

    //Variables de configuración/mensajes
    appConfig = environment.settings;
    errors: Object = {};
    msgs: Message[] = [];

    //Variables con objeto de edición
    currentUser: User;


    indicador: DashboardIndicador = new DashboardIndicador();
    indicadores: DashboardIndicador[] = [];
    indicadoresSeleccionados: DashboardIndicador[] = [];

    //Variables auxiliares
    mostrarEditor: boolean = false;
    mostrarEditorPrivilegios: boolean = false;
    cols: any[];
    multiSortMeta = [];
    usuarioCodigo: string = "";
    cargandoDataInit: boolean = false;
    procesando: boolean = false;
    ui: UIService;

    //Tipos de Indicadores
    tiposDeIndicador = [
        { name: "Gráfico", value: "grafico" },
        { name: "Tabla de Datos", value: "data" },
    ];

    clasesDeGrafico = [
        { name: "Línea", value: "line" },
        { name: "Barras", value: "bar" },
        { name: "Pastel", value: "pie" },
    ];

    constructor(
        private router: Router,
        private userService: UserService,
        private fazilService: FAZILService,
        private uiService: UIService,
        private administracionService: AdministracionService,
        private confirmationService: ConfirmationService,
        private breadcrumbService: BreadcrumbService,
        private messageService: MessageService,
    ) {
        this.ui = uiService;
        this.cargarDataConstructor();
    }

    cargarDataConstructor() {
        this.cargandoDataInit = true;
        this.breadcrumbService.setItems([
            { label: 'Administración de Indicadores', routerLink: ['administracion/indicadores'] }
        ]);
        this.cols = [
            { field: 'name', header: 'Nombre', visible: true },
            { field: 'clase', header: 'Clase', visible: true },
            { field: 'tipo', header: 'Tipo', visible: true },
            { field: 'titulo', header: 'Título', visible: true },
        ];
        this.multiSortMeta.push({ field: 'nombre', order: 1 });
    }

    ngOnInit(): void {
        this.userService.currentUser.subscribe(userData => {
            this.currentUser = userData;
            if (this.currentUser && this.currentUser.uuid) {
                this.cargarDataInit();
            }
        });
    }

    async cargarDataInit() {
        this.indicadores = await this.administracionService.getDashboardIndicadoresData();
        this.cargandoDataInit = false;
    }

    resetVariables(): void {
        this.ui.limpiarMessages();
        this.mostrarEditor = false;
        this.mostrarEditorPrivilegios = false;
        this.indicadoresSeleccionados = []; //encerar la lista de asignaciones
        this.usuarioCodigo = "";
        this.indicador = new DashboardIndicador();
    }

    nuevoIndicador(): void {
        this.resetVariables();
        this.mostrarEditor = true;
    }

    editarIndicador(dashboardIndicador: DashboardIndicador): void {
        this.resetVariables();
        this.indicador = dashboardIndicador;
        this.indicador.tipoSelected = this.indicador.tipo;
        this.indicador.claseSelected = this.indicador.clase;
        this.mostrarEditor = true;
    }

    formPrincipalCompleto() {
        return true;
    }

    guardarIndicador(): void {
        this.ui.limpiarMessages();
        if (!this.formPrincipalCompleto()) {
            this.ui.mostrarMensaje("error", `${this.appConfig.ux.formIvalid}`);
        } else {
            this.indicador.tipo = this.indicador.tipoSelected;
            this.indicador.clase = this.indicador.claseSelected;
            this.administracionService.guardarDashboardIndicador(this.indicador).subscribe(
                async (data) => {
                    this.indicador = data;
                    this.indicadores = await this.administracionService.getDashboardIndicadoresData();
                    this.ui.mostrarMensaje("success", `Actualización del usuario ${this.indicador.titulo} se realizó con éxito.`);
                    this.mostrarEditor = false;
                },
                (err) => {
                    this.ui.mostrarError(err);
                }
            );
        }
    }

    confirmarBorrarIndicador(dashboardIndicador: DashboardIndicador): void {
        this.resetVariables();
        this.confirmationService.confirm({
            message: "¿Está seguro de eliminar el indicador <strong>" + dashboardIndicador.name + "</strong>?. No será posible recuperar la información.",
            accept: () => {
                this.borrarIndicador(dashboardIndicador);
            },
        });
    }

    borrarIndicador(dashboardIndicador: DashboardIndicador): void {
        this.administracionService.borrarDashboardIndicador(dashboardIndicador.uuid).subscribe(
            async (data) => {
                this.indicadores = await this.administracionService.getDashboardIndicadoresData();
                this.ui.mostrarMensaje("success", `El indicador ${dashboardIndicador.name} ha sido eliminado con éxito.`);
            },
            (err) => {
                this.ui.mostrarError(err);
            }
        );
    }

    /**
    ** Métodos de formulario
    **/
    verificarIndicadorExistente(event) {
        //        const cedula = this.usuarioCodigo.split('-')[0];
        //        this.usuario = this.usuarios.find(val => val.code == cedula.trim()) ? this.usuarios.find(val => val.code == cedula.trim()) : new IndicadorModel();
    }

    ///////////////////////////////////////////////////////////////////////////
    //Control de acceso a acciones en pantalla
    // TODO: implementar estos métodos en todas las pantallas
    ///////////////////////////////////////////////////////////////////////////
    puedeEjecutar(accion: string): boolean {
        if (!this.currentUser || !this.currentUser.tareas) { //No tiene esta tarea
            return false;
        }

        const routerLink = this.router.url.replace("/fazil/", "");
        ////        let tarea: TareaModel = new TareaModel;
        let tarea = this.currentUser.tareas.find(val => routerLink.startsWith(val.routerLink));

        if (!tarea) { //No tiene esta tarea
            return false;
        }
        if (accion == "lectura") {
            return tarea.puedeLeer;
        } else if (accion == "crear") {
            return tarea.puedeCrear;
        } else if (accion == "escritura") {
            return tarea.puedeEscribir;
        } else if (accion == "borrado") {
            return tarea.puedeBorrar;
        } else if (accion == "aprobar") {
            return tarea.puedeAprobar;
        }
        return true;
    }

    /**
    * Lista de tareas para los roles del usuario autenticado
    */
    getTareasPermisos(routeLink: string): Promise<any> {
        return this.fazilService.getTareasPermisos(routeLink).toPromise();
    }

}